import { ApiSlugs, ListPagination, TokenVaultId, TokenVaultSummaryDto } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class TokenVaultsAdminConnector extends ApiConnector<
  TokenVaultSummaryDto,
  TokenVaultSummaryDto,
  TokenVaultId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.TOKEN_VAULTS);
  }

  list = (pagination?: ListPagination): Observable<TokenVaultSummaryDto[]> =>
    this.apiCaller.getRequest<TokenVaultSummaryDto[]>(
      this.apiPrefix,
      `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
    );

  count = (pagination?: ListPagination): Observable<number> =>
    this.apiCaller.getRequest<number>(
      this.apiPrefix,
      `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
    );

  override get = (tokenVaultId: TokenVaultId): Observable<TokenVaultSummaryDto> =>
    this.apiCaller.getRequest<TokenVaultSummaryDto>(this.apiPrefix, `${this.slug}/${tokenVaultId}`);
}
